import { TechnicalMessage } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { t } from '@translations';
import { longDate } from '@utils/date.utils';

type MessageType = number;

const labels = () => [
  t(TextCodes.TechnicalMessage.Status.Information),
  t(TextCodes.TechnicalMessage.Status.Important),
  t(TextCodes.TechnicalMessage.Status.Critical),
];

export const getMessageLabel = (type?: MessageType): string | undefined =>
  typeof type === 'number' ? labels()[type] : undefined;

export const getMessageItems = (message: TechnicalMessage) => [
  { fieldName: 'title', fieldValue: message?.title, isBold: message.isNew },
  {
    fieldName: 'messageType',
    fieldValue: message?.messageType,
    isBold: message.isNew,
  },
  { fieldName: 'date', fieldValue: longDate(message.date), isBold: message.isNew },
  { fieldName: 'text', fieldValue: message.text, isBold: message.isNew },
  {
    fieldName: 'attachments',
    fieldValue: message.documents?.length && message.documents?.length.toString(),
    isBold: message.isNew,
  },
];

export const messagesColumns = () => [
  { key: 'title', name: t(TextCodes.TechnicalMessage.Block.Title) },
  { key: 'messageType', name: t(TextCodes.TechnicalMessage.Block.MessageType) },
  { key: 'date', name: t(TextCodes.TechnicalMessage.Block.Date) },
  { key: 'text', name: t(TextCodes.TechnicalMessage.Block.Text) },
  { key: 'attachments', name: t(TextCodes.TechnicalMessage.Block.Attachments) },
];

export const technicalTypeDropdownOptions = () => [
  { value: 'Critical', label: t(TextCodes.TechnicalMessage.Status.Critical) },
  { value: 'Information', label: t(TextCodes.TechnicalMessage.Status.Information) },
  { value: 'Important', label: t(TextCodes.TechnicalMessage.Status.Important) },
];

export const technicalAttachmentsDropdownOptions = () => [
  {
    value: 'true',
    label: t(TextCodes.TechnicalMessage.Block.WithAttachments),
  },
  {
    value: 'false',
    label: t(TextCodes.TechnicalMessage.Block.WithoutAttachments),
  },
];
